import { Dialog, Button, AppBar, Toolbar, IconButton, Typography, DialogContent} from "@mui/material"
import { useState } from "react"
import { RecordContextProvider, useNotify, useRedirect, useTranslate } from "react-admin"
import { Close } from '@mui/icons-material';
import InvoiceLayout from "../InvoiceLayout";
import { useMutation } from "react-query";
import { CancelInvoiceCommand, CreateReverseInvoicePreviewCommand, InvoiceReadModel } from "../../GeneratedClients/FreeBillApi";
import { apiService } from "../../apiService";
import CustomCommandProgress from "../../customStyles/CustomCommandProgress";

interface IProps {
  invoiceId: string
  invoice: InvoiceReadModel
  userId: string
}

const CancelInvoiceDialog = ({invoiceId, invoice, userId}: IProps) => {

  const [open, setOpen] = useState<boolean>(false)
  const [preview, setPreview] = useState<InvoiceReadModel>()
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { mutate: createPreview, isLoading: isLoadingPreview } = useMutation((command: CreateReverseInvoicePreviewCommand) => 
    apiService.InvoicesApi.createReverseInvoicePreview({createReverseInvoicePreviewCommand: command, id: invoiceId})  
  )
  const { mutate: cancelInvoice, isLoading: isCancelingInvoice } = useMutation((command: CancelInvoiceCommand) => 
    apiService.InvoicesApi.cancelInvoice({cancelInvoiceCommand: command, id: invoiceId})  
  )


  const handleOpen = () => {
    if(invoice.isCanceled)
    {
      notify(translate("resources.invoices.dialogs.alreadyCanceled"))
    } else
    {
      createPreview({
        canceledInvoiceId: invoiceId 
      }, {
        onSuccess: (data) => {
          setPreview(data.data)
        },
        onError: (error: any) => {
          notify(error, {type: error})
        }
      })
      setOpen(true)  
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCancel = () => {
    cancelInvoice({id: invoiceId, userId: userId}, {
      onSuccess: () => {
        notify(translate('resources.invoices.notifications.created')) 
        redirect('list', 'reverseInvoices')
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    })
  }

  return (
    <>
      <Button 
        disabled={isLoadingPreview} 
        onClick={handleOpen} 
        type="submit"
        sx={{mr: 2}}
        size="small"
        color="error"
      >
        {translate('resources.invoices.actions.cancel')}
      </Button>

      <Dialog 
        open={open} 
        onClose={handleClose}
        fullScreen
      >
        <AppBar sx={{position: 'relative'}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component={'div'} variant="h6" color={"inherit"}>
              {translate("resources.invoices.dialogs.cancel")}
            </Typography>
            <Button variant="contained" color="error" autoFocus disabled={isCancelingInvoice} onClick={handleCancel}>{translate('resources.invoices.actions.cancel')}</Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          { (isCancelingInvoice || isLoadingPreview) && <CustomCommandProgress /> }
          <RecordContextProvider value={preview}>
            <InvoiceLayout resource="reverseInvoices" isPreview={true} />
          </RecordContextProvider>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default CancelInvoiceDialog